"use client";
import { getUserDetails } from "@/app/actions/getUserDetails";
import { useKeycloakSession } from "@/hooks/useKeycloakSession";
import { useOnceEffect } from "@/hooks/useOnceEffect";
import { getDefaultStringValue } from "@/lib/utils";
import { userDetails } from "@/types";
import { GoogleTagManager } from "@next/third-parties/google";
import { useEffect, useState, useCallback } from "react";
import { logger } from "@/lib/client-logger";

const GoogleTagManagerRender = ({ gtmId }: { gtmId: string }) => {
  const { session } = useKeycloakSession();

  const [brandName, setBrandName] = useState("");
  const [userChecked, setUserChecked] = useState(false);
  const [userId, setUserId] = useState("");

  const getBrandName = async () => {
    try {
      const { data } = await getUserDetails<userDetails>();
      const brandName = data?.roles
        ?.map((role) => {
          const { brandData: { brand, location, displayName } = {} } = role;
          return `${displayName ?? brand} - ${location}`;
        })
        .join(", ");
      setBrandName(getDefaultStringValue(brandName));
      setUserChecked(true);
    } catch (err) {
      logger.error("Error: Get User Details Error", err);
      setBrandName("");
      setUserChecked(true);
    }
  };

  useOnceEffect(() => {
    const fetchBrandName = async () => {
      await getBrandName();
    };
    fetchBrandName();
  });

  useEffect(() => {
    const id = session?.user?.id;
    if (id) {
      setUserId(id);
      globalThis.userId = id;
      globalThis.brand_name = brandName;
      globalThis.dataLayer = globalThis.dataLayer ?? [];
      globalThis.subscriptionType = session?.selectedBrand?.subscriptionType;
      globalThis.dataLayer.push({
        user_id: id,
        brand_name: brandName,
      });
    }
  }, [session?.user?.id, brandName, session?.selectedBrand?.subscriptionType]);

  const checkBrand = useCallback(() => {
    if (brandName !== "" || (userChecked && brandName === "")) return true;
    if (!userChecked && brandName === "") return false;
  }, [brandName, userChecked]);

  return userId && checkBrand() && <GoogleTagManager gtmId={gtmId} />;
};

export default GoogleTagManagerRender;
